module.exports = __webpack_public_path__ + "bin/188f6b2e06d3012841902a704ae0d4bb.png";